import { render, staticRenderFns } from "./instagram-reels-downloader.vue?vue&type=template&id=47c7f7fc"
import script from "./instagram-reels-downloader.vue?vue&type=script&lang=js"
export * from "./instagram-reels-downloader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports